import Activity from '@/types/activity';
import Dictionary from '@/types/dictionary';

export enum ACTIVITY_TYPES {
  ADD_SEARCH_ITEM = 'ADD_SEARCH_ITEM',
  INVITE_USER = 'INVITE_USER',
  SHARE_COMPARISON = 'SHARE_COMPARISON',
  OPEN_COMPARISON = 'OPEN_COMPARISON',
  DOWNLOAD_PROPOSAL = 'DOWNLOAD_PROPOSAL',
}

export enum SEARCH_ITEM_SOURCE {
  QUICKSEARCH = 'QUICKSEARCH',
  ADVANCED_SEARCH = 'ADVANCED_SEARCH',
}

export enum SEARCH_ITEM_DEST {
  PORTFOLIO = 'PORTFOLIO',
  COMPARISON = 'COMPARISON',
}

export enum ACTIVITY_FORMAT {
  CONTACT = 'Contact',
  INSIGHTS = 'Insights',
}

export const ACTIVITIES: Dictionary<{ i18nKey: string; color: string; icon: string; i18nActionKey: string }> = {
  INVITE_USER: {
    i18nKey: 'InviteUser',
    i18nActionKey: 'ActivityLog.InviteUser.Action',
    color: '#cdd4dc',
    icon: 'add-person',
  },
  SHARE_COMPARISON: {
    i18nKey: 'ShareComparison',
    i18nActionKey: 'ActivityLog.ShareComparison.Action',
    color: '#cdd4dc',
    icon: 'envelope',
  },
  OPEN_COMPARISON: {
    i18nKey: 'OpenComparison',
    i18nActionKey: 'ActivityLog.OpenComparison.Action',
    color: '#b353ff',
    icon: 'envelope-open',
  },
  DOWNLOAD_PROPOSAL: {
    i18nKey: 'DownloadProposal',
    i18nActionKey: 'ActivityLog.DownloadProposal.Action',
    color: '#009a61',
    icon: 'checkmark',
  },
};

export const formatActivityData = (activity: Activity) => {
  const { values } = activity;

  if (!values) {
    return '';
  }

  let data = {} as any;

  switch (activity.type) {
    case ACTIVITY_TYPES.INVITE_USER: {
      data = {
        email: values.user.email,
      };
      break;
    }
    case ACTIVITY_TYPES.SHARE_COMPARISON: {
      data = {
        name: `${values.user.fname} ${values.user.lname}`,
        comparisonName: values.comparisonName,
      };
      break;
    }
    case ACTIVITY_TYPES.OPEN_COMPARISON: {
      data = {
        name: `${values.user.fname} ${values.user.lname}`,
        comparisonName: values.comparisonName,
      };
      break;
    }
    case ACTIVITY_TYPES.DOWNLOAD_PROPOSAL: {
      data = {
        name: `${values.user.fname} ${values.user.lname}`,
        comparisonName: values.comparisonName,
      };
      break;
    }
  }

  return data;
};

export const getNameFromActivities = (activities: Activity[]) => {
  if (activities.length === 1 && activities[0].type === ACTIVITY_TYPES.INVITE_USER) {
    return activities[0].values.user.email;
  }

  for (const activity of activities) {
    if (activity.values.user.fname && activity.values.user.lname) {
      return `${activity.values.user.fname} ${activity.values.user.lname}`;
    }
  }
};

export default {
  ACTIVITIES,
};
